var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXsmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.376174 7.62326C0.168419 7.41549 0.168419 7.07865 0.376174 6.87088L6.87106 0.375803C7.07881 0.168041 7.41565 0.168041 7.62341 0.375803C7.83116 0.583565 7.83116 0.920413 7.62341 1.12817L1.12852 7.62326C0.920767 7.83102 0.58393 7.83102 0.376174 7.62326Z",
    fill: "#00368E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.375779 0.376186C0.583534 0.168424 0.920372 0.168424 1.12813 0.376186L7.62301 6.87127C7.83077 7.07903 7.83076 7.41588 7.62301 7.62364C7.41525 7.8314 7.07842 7.8314 6.87066 7.62364L0.375779 1.12856C0.168023 0.920796 0.168023 0.583947 0.375779 0.376186Z",
    fill: "#00368E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXsmall);
export default __webpack_public_path__ + "static/media/Xsmall.00366ca0007d9cdc15f77c65541a1168.svg";
export { ForwardRef as ReactComponent };